import { FileLink, FileText } from '../Icons';
import FileIcon from '../../utils/FileIcon';
import React, { useEffect, useState } from 'react';
import { ResourceImage } from './ResourceCardsView';
import { getImage } from '../../utils/FileHelper';
import { canPreview } from '../../utils/FileTypeHelpers';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const ResourceCard = ({ resource, onClick }) => {
	const displayNameLength = 50;
	const [url, setUrl] = useState(null);
	const [extension, setExtension] = useState('');
	const [displayName, setDisplayName] = useState(null);

	useEffect(() => {
		if (resource.type === 'ATTACHMENT') {
			if (resource.resourceAttachments.length > 0) {
				const res = resource.resourceAttachments[0];
				setDisplayName(resource.resourceAttachments[0].label);
				setExtension(res.extension);
				getImage({ id: res.key.s3ResourceId, resourceId: res.key.s3ResourceId, setImgUrl: setUrl });
			}
		} else if (resource.type === 'LINK') {
			setDisplayName(resource.resourceLinks[0].name);
		} else if (resource.type === 'INLINE') {
			setDisplayName(resource.name);
		}
	}, []);

	useEffect(() => {
		if (displayName) {
			if (displayName.length >= displayNameLength) {
				setDisplayName(displayName.slice(0, displayNameLength) + '...');
			}
		}
	}, [displayName]);

	useEffect(() => {}, [url]);

	let { name, type, meta, resourceAttachments, resourceLinks } = resource;
	let icon;

	if (type === 'LINK') {
		name = resource.resourceLinks[0].name;
		icon = <FileLink size={24} className="basis-2/12 my-0.5" />;
	} else if (type === 'INLINE') {
		icon = <FileText size={24} className="basis-2/12 my-0.5" />;
	} else if (type === 'ATTACHMENT') {
		name = resource.meta;
		if (resourceAttachments.length > 0) {
			name = resourceAttachments[0].label;
			icon = (
				<FileIcon
					className="basis-2/12 my-0.5"
					type="FILE"
					contentType={resourceAttachments[0].contentType}
					ext={resourceAttachments[0].ext}
				/>
			);
		}
	}

	function onClickResource(resource) {
		if (url && !canPreview(extension)) {
			window.open(url, '_blank');
		} else {
			onClick(resource);
		}
	}

	return (
		<div
			onClick={() => {
				onClickResource(resource);
			}}
			key={resource.id}
			className="grid grid-cols-1 gap-4 rounded-lg border border-gray-300 hover:border-gray-400 hover:cursor-pointer">
			<div className="grid grid-cols-1 relative flex items-center shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 rounded-lg ">
				<div className="h-48 justify-center flex flex-row px-0">
					<ResourceImage resource={resource} />
				</div>
				<div
					id={resource.id}
					className="flex flex-1 flex-row bg-white p-2 rounded-lg border-gray-300 h-16 justify-items-center">
					<span className="px-1 font-semibold text-sm text-gray-600 min-w-full text-center">
						{displayName}
					</span>
				</div>
			</div>
		</div>
	);
};

export default ResourceCard;
